import { type Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { useChatStore } from '../chat-store/main';

import { useConversationData } from './useConversationData';
import type { UseConversationProps } from './UseConversationProps';
import type { UseConversationResult } from './UseConversationResult';

export const useConversation = ({
	conversationId: conversationIdParam,
	assistanceServiceParams,
}: UseConversationProps = {}): UseConversationResult => {
	const [{ currentConversationId, conversations }] = useChatStore();
	const conversationId = conversationIdParam ?? currentConversationId;
	const conversation = conversations[conversationId] as Conversation | undefined;

	return useConversationData({
		conversationId,
		conversation,
		assistanceServiceParams,
	});
};
